import { Toggle } from '@warp-ds/react/components/toggle';
import type { Filters } from '@/domain';

export type CheckboxFilterProps = {
    filterType: string;
    filterData: string[];
    filterValues: string[];
    onFilterChanged: (filters: Filters) => void;
};

export const CheckboxFilter = ({ filterData, filterValues, filterType, onFilterChanged }: CheckboxFilterProps) => {
    const handleChange = (checked: boolean, item: string): void => {
        const checkedFilters = filterValues.filter((filterItem) => filterItem !== item);
        if (checked) {
            checkedFilters.push(item);
        }
        const filterObject = {};
        filterObject[filterType] = checkedFilters;
        onFilterChanged(filterObject);
    };

    return (
        <>
            {filterData.map((item) => (
                <div className="input-toggle" key={item}>
                    <Toggle
                        type="checkbox"
                        label={item}
                        checked={filterValues.includes(item)}
                        onChange={(checked: boolean) => handleChange(checked, item)}
                    />
                </div>
            ))}
        </>
    );
};
